import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import format from "date-fns/format";
import { useMemo } from "react";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";
import StartRoundedIcon from "@mui/icons-material/StartRounded";
import { useTasks } from "src/context/TasksProvider";
import { useParams } from "react-router-dom";
import { MatchParam } from "src/constants/matches";
import { capitalize } from "src/utils/capitalize";

const ProviderTaskQueue = () => {
  const { getNextTask } = useTasks();
  const { queue } = useParams<MatchParam<"QUEUE_TYPE">>();

  const currentMonth = useMemo(() => {
    return format(new Date(), "MMMM");
  }, []);

  const providerName = useClinician((p) => p.first_name + " " + p.last_name);

  const queueName = useMemo(
    () =>
      queue === "coordinator" ? "Health Navigator" : capitalize(queue || ""),
    [queue],
  );

  if (queue == null) return null;

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight={700}>
          {`${queueName} Task Queue`}
        </Typography>
        <Button endIcon={<StartRoundedIcon />} onClick={getNextTask}>
          Find patient
        </Button>
      </Stack>
      <Stack
        gap={4}
        p={2.5}
        sx={{ borderRadius: "6px", border: "1px solid #E5E5E5" }}
        maxWidth="600px"
        width="100%"
        height="fit-content"
      >
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6">{providerName}</Typography>
          <Typography variant="h6">{currentMonth}</Typography>
        </Stack>
        {/* <Stack direction="row" justifyContent="space-between">
          <Stack alignItems="center">
            <Typography fontWeight={700}>Total tasks</Typography>
            <Typography>X.XX</Typography>
          </Stack>
          <Stack alignItems="center">
            <Typography fontWeight={700}>Total points</Typography>
            <Typography>X.XX</Typography>
          </Stack>
          <Stack alignItems="center">
            <Typography fontWeight={700}>Efficiency</Typography>
            <Typography>X.XX</Typography>
          </Stack>
        </Stack> */}
      </Stack>
    </Stack>
  );
};

export default ProviderTaskQueue;
